import(/* webpackMode: "eager" */ "/app/app/components/ClientOnly.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/FeedbackWidget.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/GameBanner.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/navbar/Navbar.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/ThemeProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/app/providers/SessionProviderWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/providers/ToasterProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"inter\"}");
